import { declOfNum } from '../../../../helpers/dspx-utils';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import { intervalTypesMap } from '../../shared/configs/selectionData/intervalTypes';
import {
  createMapScheduleSettingIntervalsToForm,
  mapScheduleSettingInterval,
} from './mapScheduleSettingInterval';
import { mapToPayload } from './mapToPayload';
import { asIs, extractKeyFromLabel } from './methods';

const {
  intervalsPerDay: productivityName,
  ignoreIntervalsPerDay: ignoreProductivityName,
  intervals: intervalsName,
  dayType: dayTypeName,
  duration: durationName,
  start: startName,
  end: endName,
} = fieldNames.deskScheduleSetting;

const { intervalId: intervalIdName } = fieldNames.scheduleSettingInterval;

const mapper = {
  [productivityName]: extractKeyFromLabel,
  [ignoreProductivityName]: asIs,
  [intervalsName]: mapScheduleSettingInterval,
};

export const createMapDesksScheduleSettings = ({ isCommonSettings, days }) => {
  if (isCommonSettings) {
    const map = createMapDeskScheduleSettingsForAllDays(days);
    return map;
  }

  return mapDeskScheduleSettingsForEveryDay;
};

export const createMapDeskScheduleSettingsToForm = ({
  timeIntervals,
  intervalType,
  isCommonSchedules = false,
}) => {
  const mapIntervals = createMapScheduleSettingIntervalsToForm({
    timeIntervals,
    intervalType,
  });

  function createValue(setting) {
    return {
      [productivityName]: createProductivityValue(setting[productivityName]),
      [ignoreProductivityName]: setting[ignoreProductivityName],
      [intervalsName]: mapIntervals(setting[intervalsName]),
      ...createScheduleValues({
        intervals: setting[intervalsName],
        intervalType,
        timeIntervals,
      }),
    };
  }

  return (settings) => {
    return isCommonSchedules
      ? createValue(settings[0])
      : settings.reduce((acc, setting) => {
          acc[`${setting[dayTypeName]}str`] = createValue(setting);
          return acc;
        }, {});
  };
};

function createProductivityValue(val) {
  return {
    key: val,
    label:
      val === 0
        ? 'Все'
        : `${val} ${declOfNum(val, [
            'интервал',
            'интервала',
            'интервалов',
          ])} в день`,
  };
}

function createScheduleValues({ intervals, intervalType, timeIntervals }) {
  if (intervalType === intervalTypesMap.classic) {
    const firstId = intervals[0][intervalIdName];
    const lastId = intervals[intervals.length - 1][intervalIdName];

    const first = timeIntervals.getIntervalById(firstId);
    const last = timeIntervals.getIntervalById(lastId);

    return {
      [durationName]: first.duration,
      [startName]: first.from,
      [endName]: last.to,
    };
  }
}

function mapDeskScheduleSettingsForEveryDay(settings, isDraft) {
  return Object.entries(settings).map(([key, value]) => ({
    [dayTypeName]: isDraft ? key : parseInt(key, 10),
    ...mapToPayload(value, mapper),
  }));
}

function createMapDeskScheduleSettingsForAllDays(days) {
  function map(settings, isDraft) {
    const payload = mapToPayload(settings, mapper, isDraft);
    return days.map((day) => {
      return { [dayTypeName]: day, ...payload };
    });
  }

  return map;
}
